import { Component, OnInit } from '@angular/core';
import {
	AbstractControl,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConstantsService, PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Address } from 'src/app/shared/models/address';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import { Employee } from 'src/app/shared/models/employee/employee';

import { User } from 'src/app/shared/models/security/user';
import { EmployeeType } from 'src/app/shared/models/employee/employee-type';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { NotificationType } from 'src/app/shared/enums/notification-type.enum';
import { NotificationEmail, SendEmail } from 'src/app/shared/models/notificationEmail';
import { Prestation } from 'src/app/shared/models/prestation';
import { DataStorageService } from 'src/app/core/services/dataStorage/data-storage.service';

@Component({
	selector: 'app-employee-modal-ajout',
	templateUrl: './employee-modal-ajout.component.html',
	styleUrls: ['./employee-modal-ajout.component.scss']
})
export class EmployeeModalAjoutComponent implements OnInit {
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };
	isAddressSelected: { value: boolean } = { value: false };

	LABEL_INTERVENANT: string;
	notificationEmail : NotificationEmail;
	sendMail = new SendEmail();
	listNotificationType = NotificationType;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+$");
	PHONE_NUMBER_PATTERN = '0{1}[0-9]{9}';

	formAjout: FormGroup = new FormGroup(
		{
			firstName: new FormControl('', [
				Validators.required,
				Validators.maxLength(this.MAX_NAME_CHAR),
				//Validators.pattern(this.NAME_PATTERN)
			]),
			lastName: new FormControl('', [
				Validators.required,
				Validators.maxLength(this.MAX_NAME_CHAR),
				//Validators.pattern(this.NAME_PATTERN)
			]),
			
			birthDate: new FormControl<Date>(null),
			// address: new FormControl(new Address().label, [
			// 	Validators.required,
			// 	Validators.maxLength(60)
			// ]),
			telephone: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
			statutInt: new FormControl('', Validators.required),
			email: new FormControl('', Validators.email),
			nomStructure: new FormControl(''),
			typeStructure: new FormControl(''),
			emailStructure: new FormControl('', Validators.email),
			addressStructure: new FormControl(new Address().label, [
				// Validators.maxLength(60)
			]),
			phoneStructure: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
			username: new FormControl('', [Validators.required])
		},
		{ validators: emailRequiredOnEmployeeType }
	);

	center: ServiceCenter;
	user: User;
	employee = new Employee();

	constructor(
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		public bsModalRef: BsModalRef,
		private appConstants: ConstantsService,
		private dataStorageService: DataStorageService
	) {}

	ngOnInit(): void {
		this.LABEL_INTERVENANT = this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
		this.user = this.facade.dataStorageService.getUser();
		if (this.user) {
			//this.center = this.user.employee.serviceCenter;
		}
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.facade.employeeService.addEmployee(this.employee).subscribe({
			next: (savedEmployee: Employee) => {
				this.facade.notificationEmailService.getAllNotificationEmail().subscribe({
					next: (val) => {
						this.notificationEmail = val.find(x => x.type == this.listNotificationType.CREATION_COMPTE)
						this.sendMail.email = this.employee.email;
						this.sendMail.notificationEmail = this.notificationEmail;
						this.sendMail.prestation = new Prestation();
						this.sendMail.user = new User({id: savedEmployee.id, username:savedEmployee.username, 
							firstName:savedEmployee.firstName, lastName:savedEmployee.lastName, motDePasseGenere:savedEmployee.motDePasseGenere});
						this.facade.notificationEmailService.sendEmail(this.sendMail).subscribe({
							complete: () =>{
								this.isValidateButtonClicked.value = false;
								this.bsModalRef.hide();
							}
						})
					}
				}),
				this.facade.authenticationService.authenticateIsy(this.appConstants.loginIsy, this.appConstants.passwordIsy).subscribe({
					next: (val) => {
						this.dataStorageService.setTokenIsy(val.token);
						console.log(val);
						this.facade.employeeService.addEmployeeIsy(this.employee).subscribe({
							next : (val) => {
								console.log(val);
							}
						});
					}
						
				})
			},
			error: (err: ErrorResponse) => {
				this.isValidateButtonClicked.value = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message,
					err.status
				);
			}
		});
	}
}

export const emailRequiredOnEmployeeType: ValidatorFn = (
	control: AbstractControl
): ValidationErrors | null => {
	const statutInt = control.get('statutInt').value;
	const email = control.get('email').value;

	return statutInt === 'INT' && (!email || email === '')
		? { emailRequired: true }
		: null;
};
